import { useEffect } from "react"
import { useFormikContext } from "formik"

export function AutoValidate({ setBlockFormValid }: { setBlockFormValid: (valid: boolean) => void }) {
  const { values, validateForm } = useFormikContext<any>()

  useEffect(() => {
    let mounted = true

    ;(async () => {
      const errs = await validateForm()
      if (!mounted) return
      const hasErrors = Object.keys(errs || {}).length > 0
      setBlockFormValid(!hasErrors)
    })()

    return () => {
      mounted = false
    }
  }, [values, validateForm, setBlockFormValid])

  return null
}
